import React, { useRef, useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
const GoldenTunnelLineGraph = (props) => {
  const chart = useRef(null);

  useLayoutEffect(() => {
    let x = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.XYChart
    );
    if (props.data) {
      //title
      var title = x.titles.create();
      title.text = props.title;
      title.fontSize = 20;
      title.fontWeight = 600;
      title.marginBottom = 30;
      title.fill = "lightgrey";

      // var chart = x.series.push(new am4charts.Chart());
      // // var chart = x.chart.create();
      // chart.background.fill = '#0f0';
      // chart.background.opacity = 0.5;

      // Create axes
      var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = props.category
        ? props.category
        : "_id";
      categoryAxis.renderer.minGridDistance = 30;
      // categoryAxis.renderer.labels.template.rotation = 45;
      categoryAxis.renderer.labels.template.horizontalCenter = "left";
      categoryAxis.renderer.labels.template.fontSize = 11;
      categoryAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.labels.template.rotation = props.rotation
        ? props.rotation
        : 0;
      categoryAxis.renderer.line.stroke = am4core.color("#000");

      var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.labels.template.fontSize = 11;
      valueAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      valueAxis.renderer.line.strokeOpacity = 0.2;
      valueAxis.renderer.line.strokeWidth = 1;
      valueAxis.renderer.line.stroke = am4core.color("#000");

      // Create series

      var seriesRdg = x.series.push(new am4charts.LineSeries());
      seriesRdg.dataFields.valueY = props.valRdg;
      seriesRdg.dataFields.categoryX = props.category;
      seriesRdg.tooltipText = "{value}";
      seriesRdg.strokeWidth = 5;
      seriesRdg.name = props.legendRdg;
      seriesRdg.minBulletDistance = 15;
      seriesRdg.yAxis = valueAxis;
      seriesRdg.stroke = props.colorRdg
        ? am4core.color(props.colorRdg)
        : "color";
      seriesRdg.fill = props.colorRdg ? am4core.color(props.colorRdg) : "color";
      seriesRdg.legendSettings.labelText = "[{stroke}]{name}[/]";

      // series.legendSettings.labelText = "HHHHHHH";

      // Create series
      var seriesTgt = x.series.push(new am4charts.LineSeries());
      seriesTgt.dataFields.valueY = props.valTgt;
      seriesTgt.dataFields.categoryX = props.category;
      seriesTgt.tooltipText = "{value}";
      seriesTgt.name = props.legendTgt;
      seriesTgt.strokeWidth = 1;
      seriesTgt.yAxis = valueAxis;
      seriesTgt.minBulletDistance = 15;
      seriesTgt.stroke = props.colorTgt
        ? am4core.color(props.colorTgt)
        : "color";
      seriesTgt.fill = props.colorTgt ? am4core.color(props.colorTgt) : "color";
      seriesTgt.legendSettings.labelText = "[{stroke}]{name}[/]";

      // Create series
      var seriesUcl = x.series.push(new am4charts.LineSeries());
      seriesUcl.dataFields.valueY = props.valUcl;
      seriesUcl.dataFields.categoryX = props.category;
      seriesUcl.tooltipText = "{value}";
      seriesUcl.name = props.legendUcl;
      seriesUcl.strokeWidth = 1;
      seriesUcl.yAxis = valueAxis;
      seriesUcl.minBulletDistance = 15;
      seriesUcl.stroke = props.colorUcl
        ? am4core.color(props.colorUcl)
        : "color";
      seriesUcl.fill = props.colorUcl ? am4core.color(props.colorUcl) : "color";
      seriesUcl.legendSettings.labelText = "[{stroke}]{name}[/]";

      // Create series
      var seriesLcl = x.series.push(new am4charts.LineSeries());
      seriesLcl.dataFields.valueY = props.valLcl;
      seriesLcl.dataFields.categoryX = props.category;
      seriesLcl.tooltipText = "{value}";
      seriesLcl.name = props.legendLcl;
      seriesLcl.strokeWidth = 1;
      seriesLcl.yAxis = valueAxis;
      seriesLcl.minBulletDistance = 15;
      seriesLcl.stroke = props.colorLcl
        ? am4core.color(props.colorLcl)
        : "color";
      seriesLcl.fill = props.colorLcl ? am4core.color(props.colorLcl) : "color";
      seriesLcl.legendSettings.labelText = "[{stroke}]{name}[/]";

      // Create series
      // var seriesUsl = x.series.push(new am4charts.LineSeries());
      // seriesUsl.dataFields.valueY = props.valUsl;
      // seriesUsl.dataFields.categoryX = props.category;
      // seriesUsl.tooltipText = "{value}";
      // seriesUsl.name =  props.legendUsl;
      // seriesUsl.strokeWidth = 1;
      // seriesUsl.yAxis = valueAxis;
      // seriesUsl.minBulletDistance = 15;
      // seriesUsl.stroke = props.colorUsl
      //   ? am4core.color(props.colorUsl)
      //   : "color";
      // seriesUsl.fill = props.colorUsl
      //   ? am4core.color(props.colorUsl)
      //   : "color";
      // seriesUsl.legendSettings.labelText = "[{stroke}]{name}[/]";

      // Create series
      // var seriesLsl = x.series.push(new am4charts.LineSeries());
      // seriesLsl.dataFields.valueY = props.valLsl;
      // seriesLsl.dataFields.categoryX = props.category;
      // seriesLsl.tooltipText = "{value}";
      // seriesLsl.name =  props.legendLsl;
      // seriesLsl.strokeWidth = 1;
      // seriesLsl.yAxis = valueAxis;
      // seriesLsl.minBulletDistance = 15;
      // seriesLsl.stroke = props.colorLsl
      //   ? am4core.color(props.colorLsl)
      //   : "color";
      // seriesLsl.fill = props.colorLsl
      //   ? am4core.color(props.colorLsl)
      //   : "color";
      // seriesLsl.legendSettings.labelText = "[{stroke}]{name}[/]";

      // Add legend
      x.legend = new am4charts.Legend();
      x.legend.fill = "#b1b0b5";

      // Make a panning cursor
      x.cursor = new am4charts.XYCursor();
      x.cursor.behavior = "panXY";
      x.cursor.xAxis = categoryAxis;
      x.cursor.snapToSeries = seriesRdg;

      x.data = props.data;

      chart.current = x;
    }
    return () => {
      x.dispose();
    };
  }, []);

  return (
    <div className="App">
      <div
        id={props.divId ? props.divId : "DivID"}
        style={{
          backgroundColor: "#000406",
          width: "95%",
          height: "600px",
          padding: "10px",
          margin: "10px",
          boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
          borderRadius: "10px",
        }}
      ></div>
    </div>
  );
};

export default GoldenTunnelLineGraph;
